export const CACHE_VERSION = "v1.1.13";
